<template>
  <span>
    <div><span style="color: red;margin-right:4px">*</span>{{scope.text}}</div>
  </span>
</template>

<script>
export default {
  props: {
    instance: Object,
    scope: Object // text, index, scope
  },
  data() {
    return {

    }
  },
  methods: {
    // actionCb(row) {
    //   const { cb } = this.instance
    //   this.$emit('actionClick', { row, cb})
    // }
  }
}
</script>
